/*
 * @Author: 秦少卫
 * @Date: 2024-08-17 09:59:49
 * @LastEditors: 秦少卫 nihaojob@163.com
 * @LastEditTime: 2025-08-02 16:42:40
 * @Description: file content
 */

import axios, { AxiosInstance, AxiosResponse } from 'axios';
import qs from 'qs';
import * as _ from 'lodash-es';
const baseURL = import.meta.env.APP_APIHOST;

// 扩展 Axios 配置类型，添加 skipResponse 属性
declare module 'axios' {
  interface AxiosRequestConfig {
    skipResponse?: boolean;
  }
}
// 获取baseURL 优先使用localStorage
export function getBaseURL() {
  return localStorage.getItem('baseURL') || baseURL;
}

const tokenKey = 'token';
function getToken() {
  const token = localStorage.getItem(tokenKey);
  return token;
}

const getValue = (item: any) => {
  const newData: any = {
    id: item.id,
  };

  if (item.attributes) {
    Object.keys(item.attributes).forEach((key) => {
      const info = item.attributes[key];
      newData[key] = info;
      if (_.isObject(info)) {
        const itemId = _.get(info, 'data.id');
        const itemUrl = String(_.get(info, 'data.attributes.url') || '');
        const itemImgFormats = _.get(info, 'data.attributes.formats');
        // id、url、图片 Format 属性新增
        if (itemId) {
          newData[key + 'Id'] = itemId;
        }
        if (itemUrl) {
          const hasHttp = itemUrl.startsWith('http');
          newData[key + 'Url'] = hasHttp ? itemUrl : getBaseURL() + itemUrl;
        }
        if (itemImgFormats) {
          addImgFormat(newData, key, itemImgFormats);
        }
      }
    });
  } else {
    // admin 接口过滤
    Object.keys(item).forEach((key) => {
      const info = item[key];
      newData[key] = info;

      //判断info是不是Object
      if (_.isObject(info)) {
        const itemId = _.get(info, 'id');
        const itemUrl = String(_.get(info, 'url')); //取得info里的url项数据
        const itemFirstName = _.get(info, 'firstname');
        const itemLastName = _.get(info, 'lastname');
        if (itemId) {
          newData[`${key}Id`] = itemId;
        }
        if (itemUrl) {
          const hasHttp = itemUrl.startsWith('http');
          newData[`${key}Url`] = hasHttp ? itemUrl : getBaseURL() + itemUrl;
        }
        if (itemFirstName && itemLastName) {
          newData[`${key}FullName`] = itemFirstName + itemLastName;
        }
      }
      // 适配上传接口
      if (key === 'url') {
        const hasHttp = info?.startsWith('http');
        newData[`formatUrl`] = hasHttp ? info : getBaseURL() + info;
      }
    });
  }
  return newData;
};

const addImgFormat = (data: any, key: string, item: any) => {
  Object.keys(item).forEach((imgKey) => {
    const hasHttp = item[imgKey].url.startsWith('http');
    data[key + 'Url' + _.capitalize(imgKey)] = hasHttp
      ? item[imgKey].url
      : getBaseURL() + item[imgKey].url;
  });
};

const mapValue = (arr: any) => {
  return arr.map((item: any) => getValue(item));
};

interface IPageParams {
  [key: string]: any;
  pagination?: {
    page: number;
    pageSize: number;
  };
}

export default class ServerApi {
  instance: AxiosInstance;
  apiPath: string;
  constructor(path: string, hasToken?: boolean) {
    this.apiPath = path;
    this.instance = this._initInstance(hasToken);
  }
  _initInstance(hasToken?: boolean) {
    const instance = axios.create({ baseURL: getBaseURL() });
    createInstance(instance, hasToken, true, getToken);
    return instance;
  }
  // 查询详情
  get(id: string | number, data = {}) {
    return this.instance.get(`${this.apiPath}/${id}?${qs.stringify(data)}`);
  }
  // 添加
  add(data = {}) {
    return this.instance.post(this.apiPath, data);
  }
  // 删除
  del(id: string | number) {
    return this.instance.delete(`${this.apiPath}/${id}`);
  }

  getPublic(id: string | number, data = {}) {
    return this.instance.get(`${this.apiPath}/public/${id}?${qs.stringify(data)}`);
  }

  // 查找
  getPublicFind(data = {} as IPageParams, pageSize?: number) {
    if (JSON.stringify(data) === '{}') {
      // 如果为空，则默认分页
      data.pagination = {
        page: 1,
        pageSize: pageSize || 100,
      };
    } //否则按照传入的data走，如果有pageSize，则覆盖
    if (pageSize) {
      if (data.pagination) {
        data.pagination.pageSize = pageSize;
      } else {
        data.pagination = {
          page: 1,
          pageSize: pageSize,
        };
      }
    }
    return this.instance.get(`${this.apiPath}/public/?${qs.stringify(data)}`);
  }

  // 查找
  find(data = {} as IPageParams, pageSize?: number) {
    if (JSON.stringify(data) === '{}') {
      // 如果为空，则默认分页
      data.pagination = {
        page: 1,
        pageSize: pageSize || 100,
      };
    } //否则按照传入的data走，如果有pageSize，则覆盖
    if (pageSize) {
      if (data.pagination) {
        data.pagination.pageSize = pageSize;
      } else {
        data.pagination = {
          page: 1,
          pageSize: pageSize,
        };
      }
    }
    return this.instance.get(`${this.apiPath}/?${qs.stringify(data)}`);
  }
  // 更新
  update(id: string, data = {}) {
    return this.instance.put(`${this.apiPath}/${id}`, data);
  }

  IGet(data = {}, skip = true) {
    return this.instance.get(`${this.apiPath}`, {
      params: data,
      skipResponse: skip,
    });
  }
  IPost(data = {}, skip = true) {
    return this.instance.post(`${this.apiPath}`, data, {
      skipResponse: skip,
    });
  }
}
// 后续需要改gettoken的入参
export function createInstance(
  instance: AxiosInstance,
  hasToken?: boolean,
  isResponseData = true,
  getToken?: any
) {
  // 统一处理请求数据
  instance.interceptors.request.use(function (config: any) {
    const token = getToken();
    if (token && hasToken) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  });

  // 统一处理返回数据
  instance.interceptors.response.use(function (response: AxiosResponse) {
    if (!response.config.skipResponse as any) {
      if (response.data?.data?.attributes) {
        response.data.data = getValue(response.data.data);
      }
      if (response.data?.data?.length) {
        response.data.data = mapValue(response.data.data);
      }
      // admin 接口过滤
      if (response.data?.results?.length) {
        response.data.results = mapValue(response.data.results);
      }
      if (_.isArray(response.data)) {
        response.data = mapValue(response.data);
      }

      if (response.data?.meta?.pagination) {
        response.data.pagination = response.data.meta.pagination;
        delete response.data.meta;
      }
    }
    return isResponseData ? response.data : response;
  });
  return instance;
}
